/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { People1GearIcon16Light } from './People1GearIcon16Light';
import { People1GearIcon16Regular } from './People1GearIcon16Regular';
import { People1GearIcon16Solid } from './People1GearIcon16Solid';
import { People1GearIcon20Light } from './People1GearIcon20Light';
import { People1GearIcon20Regular } from './People1GearIcon20Regular';
import { People1GearIcon20Solid } from './People1GearIcon20Solid';
import { People1GearIcon24Regular } from './People1GearIcon24Regular';
import { People1GearIcon24Solid } from './People1GearIcon24Solid';
import { People1GearIcon32Regular } from './People1GearIcon32Regular';
import { People1GearIcon64Regular } from './People1GearIcon64Regular';
var sizes = {
    16: {
        light: People1GearIcon16Light,
        regular: People1GearIcon16Regular,
        solid: People1GearIcon16Solid,
    },
    20: {
        light: People1GearIcon20Light,
        regular: People1GearIcon20Regular,
        solid: People1GearIcon20Solid,
    },
    24: {
        regular: People1GearIcon24Regular,
        solid: People1GearIcon24Solid,
    },
    32: {
        regular: People1GearIcon32Regular,
    },
    64: {
        regular: People1GearIcon64Regular,
    },
};
export var People1GearIcon = forwardRef('People1GearIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
